module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAQRJREFUGBl1kLFKxEAURXdmxSZF0qiN5Bv8FJeFQQTFJkknWFjYWoidsF2SD3AZEGz0O+ystRFkMakFiecOE9liHZi8d+898yaMmaytpmnmyCt2PgzDmzHmtizLhxGxYwN4BnAJcAKwa609lZY/Mn8wwTXmrCiKV4WxzqIf+AC3bbuPWlVV9RHc+Il6FfNJgNM0/eT6Pe/9dB2Wlq9cfoCdc99c99z3/Q3VKFCVpn1SLi8ETNgmWAAc4b0z7YX+gD6nX2ZZdq4DNk5YUneSJMkBHNurSsvvuu5enKnr+pjTjuc6BNi4eL5HYL9FWtFcbKSiSa5nvdPkL5ofpg//HdAvkE1/AbB9hwTpYTNdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-fans-count.png
// module id = 1081
// module chunks = 0